import { makeStyles, Theme } from "@material-ui/core";

type Props = {
  background: string;
};
const useStyles = makeStyles<Theme, Props>((theme: Theme) => ({
  root: {
    maxWidth: 1200,
    margin: "0 auto",
    boxSizing: "border-box",
  },
  background: {
    background: "linear-gradient(135deg, #0F172A 0%, #1E1B4B 50%, #312E81 100%)",
    borderRadius: 24,
    padding: "32px 36px",
    color: "#FFFFFF",
    marginBottom: 28,
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 12px 32px rgba(15, 23, 42, 0.15)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 20,
    minHeight: 120,
    boxSizing: "border-box",
    [theme.breakpoints?.down("sm")]: {
      padding: "20px 18px",
      borderRadius: 16,
      minHeight: "auto",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: "-40%",
      right: "-10%",
      width: 300,
      height: 300,
      background: "radial-gradient(circle, rgba(99, 102, 241, 0.25) 0%, rgba(99, 102, 241, 0) 70%)",
      pointerEvents: "none",
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    zIndex: 2,
  },
  header_title: {
    display: 'flex',
    alignItems: 'center',
    "& > h6": {
      color: "#FFFFFF !important",
      fontSize: "1.75rem !important",
      fontWeight: "800 !important",
      margin: "0 !important",
      marginRight: "20px !important",
      position: "relative !important",
      left: "auto !important",
      top: "auto !important",
      bottom: "auto !important",
      zIndex: 2,
      [theme.breakpoints?.down("sm")]: {
        fontSize: "1.25rem !important",
      },
    },
    "& > div": {
      zIndex: 999,
      cursor: 'pointer',
      color: "#FFFFFF",
      "& svg": {
        fontSize: 24,
      }
    }
  },

  title: {
    color: "#004673",
    fontSize: 25,
    fontWeight: 700,
    padding: "10px 0",
  },
  btn_delete_fitler: {
    color: "#0284C7",
    backgroundColor: "#F0F9FF",
    borderRadius: 8,
    padding: "6px 14px",
    alignSelf: "center",
    fontSize: 12,
    fontWeight: 700,
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#0284C7",
      color: "#FFFFFF",
    },
  },

  btn_detail: {
    color: "#4F46E5",
    backgroundColor: "#EEF2FF",
    borderRadius: 8,
    fontSize: 12,
    fontWeight: 700,
    padding: "6px 14px",
    border: "none",
    cursor: "pointer",
    textTransform: "none",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "#4F46E5",
      color: "#FFFFFF",
      boxShadow: "0 4px 12px rgba(79, 70, 229, 0.25)",
    },
  },
  btn_edit: {
    color: "#0284C7",
    backgroundColor: "#F0F9FF",
    borderRadius: 8,
    fontSize: 12,
    fontWeight: 700,
    padding: "6px 14px",
    margin: "0 4px",
    border: "none",
    cursor: "pointer",
    textTransform: "none",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "#0284C7",
      color: "#FFFFFF",
      boxShadow: "0 4px 12px rgba(2, 132, 199, 0.25)",
    },
  },
  btn_create: {
    background: "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)",
    borderRadius: 10,
    fontSize: 13,
    fontWeight: 700,
    color: "#FFFFFF",
    padding: "0 22px",
    height: 42,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0",
    border: "none",
    cursor: "pointer",
    textTransform: "none",
    boxShadow: "0 4px 12px rgba(37, 99, 235, 0.25)",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    whiteSpace: "nowrap",
    "&:hover": {
      background: "linear-gradient(135deg, #1D4ED8 0%, #1E40AF 100%)",
      boxShadow: "0 6px 16px rgba(37, 99, 235, 0.35)",
    },
    [theme.breakpoints?.down("sm")]: {
      width: "100% !important",
      margin: "0 !important",
    },
  },
  btn_delete: {
    color: "#DC2626",
    backgroundColor: "#FEF2F2",
    borderRadius: 8,
    fontSize: 12,
    fontWeight: 700,
    padding: "6px 14px",
    marginRight: 4,
    border: "none",
    cursor: "pointer",
    textTransform: "none",
    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "#DC2626",
      color: "#FFFFFF",
      boxShadow: "0 4px 12px rgba(220, 38, 38, 0.25)",
    },
  },
  btn_upload: {
    background: "rgba(255, 255, 255, 0.12)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    borderRadius: 12,
    fontSize: "0.8rem",
    fontWeight: 700,
    color: "#FFFFFF",
    padding: "10px 20px",
    cursor: "pointer",
    textTransform: "uppercase",
    textAlign: "center",
    transition: "all 0.2s ease",
    backdropFilter: "blur(4px)",
    "&:hover": {
      background: "#FFFFFF",
      color: "#0F172A",
      boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
    },
  },

  avatar: {
    width: 25,
    height: 25,
    objectFit: "cover",
    borderRadius: "50%",
    [theme.breakpoints?.up("xl")]: {
      width: 30,
      height: 30,
    },
  },

  name: {
    width: "100%",
    textAlign: "left",
    paddingLeft: 5,
    fontSize: 11,
    [theme.breakpoints?.up("xl")]: {
      fontSize: 13,
    },
  },
  selectFilter: {
    borderRadius: 12,
    backgroundColor: "#fff",
  },
  inputLabel: {
    width: "90%",
    textAlign: "center",
  },
  container: {
    maxHeight: '57vh',
    [theme.breakpoints?.down("sm")]: {
      display: "none",
    },
  },
  root_modal: {
    width: "100%",
    height: "60%",
    display: "flex",
    justifyContent: "center",
  },
  modal__container: {
    width: "100%",
    maxWidth: 400,
    height: 250,
    borderRadius: 12,
    backgroundColor: "#fff",
    zIndex: 9,
    display: "flex",
    flexDirection: "column",
    margin: "30px 0",
  },

  modal__create__container: {
    width: "100%",
    height: 'fit-content',
    borderRadius: 12,
    backgroundColor: "#fff",
    zIndex: 9,
    display: "flex",
    flexDirection: "column",
    margin: "30px 0",
    maxWidth: 800,
    marginTop: 200
  },

  modal__header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 24px",
    minHeight: 65,
    borderBottom: "1px solid rgb(235, 235, 235)",
    "& >h6": {
      fontWeight: 700,
      fontSize: 18,
    },
  },

  form__button: {
    background: "linear-gradient(360deg, #399BD9 0%, #83CFFF 172.67%)",
    color: "#fff",
    marginTop: 15,
    borderRadius: 10,
  },

  filterToolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "20px 0",
    gap: 16,
    position: "sticky",
    top: 76,
    zIndex: 100,
    backgroundColor: "rgba(255, 255, 255, 0.85)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    padding: "14px 20px",
    borderRadius: 16,
    boxShadow: "0 10px 30px -10px rgba(0, 0, 0, 0.05)",
    border: "1px solid rgba(226, 232, 240, 0.8)",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "& .MuiOutlinedInput-root": {
      height: 42,
      borderRadius: 10,
      backgroundColor: "#FFFFFF",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 14px",
      fontSize: "0.875rem",
    },
    [theme.breakpoints?.down("sm")]: {
      top: 68,
      padding: "10px 12px",
      borderRadius: 12,
      flexDirection: "column",
      gap: 12,
    },
  },
  stickyActive: {
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05) !important",
    border: "1px solid rgba(15, 23, 42, 0.08) !important",
    backgroundColor: "#FFFFFF !important",
  },
  mobileListView: {
    display: "none",
    [theme.breakpoints?.down("sm")]: {
      display: "block",
      padding: "0 10px",
    },
  },
  mobileCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    border: "1px solid #E2E8F0",
    padding: 16,
    marginBottom: 12,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.02)",
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
    "&:active": {
      transform: "scale(0.98)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    },
  },
  mobileCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  mobileCardBody: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    marginBottom: 14,
    backgroundColor: "#F8FAFC",
    padding: "12px 14px",
    borderRadius: 10,
  },
  mobileCardRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  mobileCardActions: {
    display: "flex",
    gap: 8,
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },
  mobileAvatar: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    objectFit: "cover",
  },
  paginationContainer: {
    marginTop: 24,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    padding: "16px 24px",
    borderRadius: 16,
    border: "1px solid #E2E8F0",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
    [theme.breakpoints?.down("sm")]: {
      flexDirection: "column",
      gap: 12,
      padding: "16px 12px",
      borderRadius: 12,
    },
  },
}));

export default useStyles;
